module.exports = __webpack_public_path__ + "img/Mask Group 2925@2x.3611df24.png";